import React from "react"
import { Controller, } from "react-hook-form"
import { FormControl, FormControlLabel, FormLabel, TextField, FormHelperText, Checkbox } from "@fedsim/components"
import { enGB } from 'date-fns/locale'
import { DatePicker } from 'react-nice-dates'
import 'react-nice-dates/build/style.css'

export const FormDate = ({ name, control, label, size = "small", variant = "filled", }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, }, fieldState: { error, }, }) => {
        const clickHandle = (event) => event.target.value === "on" ? onChange('') : onChange(new Date())
        return (
          <FormControl fullWidth>
            <FormLabel>{label}</FormLabel>
            {error && <FormHelperText>{error.message}</FormHelperText>}
            <DatePicker date={value ? new Date(value) : ''} onDateChange={onChange} locale={enGB}>
              {({ inputProps, focused }) => (
                <>
                  <FormControlLabel control={<Checkbox checked={value === ''} onClick={clickHandle} />} label="Reset Date" />
                  <TextField
                    className={'input' + (focused ? ' -focused' : '')}
                    size={size} variant={variant}
                    fullWidth
                    {...inputProps}
                  />
                </>
              )}
            </DatePicker>
          </FormControl>
        )
      }}
    />
  )
}

export default FormDate
